import React from 'react';
import { useApp } from '@/contexts/AppContext';
import { ThemeProvider } from '@/contexts/theme';

export interface AuthLayoutProps {
  children: React.ReactNode;
}

/**
 * AuthLayout - Wrapper para paginas de autenticacao
 *
 * Usa ThemeProvider com forceMode="dark" — os mockups de auth (login/register/
 * reset) usam fundo dark navy (`--bg-page:#0e1524`) com painel de marca roxo.
 * Sem company overrides (usuario nao esta autenticado).
 */
export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const { app } = useApp();

  return (
    <ThemeProvider
      baseThemeId={app?.baseThemeId}
      appOverrides={app?.themeOverrides}
      forceMode="dark"
    >
      {children}
    </ThemeProvider>
  );
};

AuthLayout.displayName = 'AuthLayout';
